import React from 'react';

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p className="text-xl mt-20">
          From exploring different tech stacks to finally realizing myself as a
          Self Assertive Creative Person & thus about my passion in Front End
          Development. Love to blend the art of design & creativity with the
          skill of programming to deliver an immersive and engaging user
          experience through efficient Website Development.
        </p>

        <br />

        <p className="text-xl">
          {/* Sint elit dolor quis dolore et deserunt cupidatat cupidatat mollit
          exercitation incididunt ex. Incididunt ipsum sint reprehenderit
          voluptate commodo sunt velit non ipsum. Incididunt pariatur fugiat
          nulla adipisicing. */}
        </p>
      </div>
    </div>
  );
};

export default About;
